import PropTypes from 'prop-types';

import {BREAKPOINTS} from '../../../../../const';
import useBreakpoint from '../../../../../hooks/dom/useBreakpoint';
import useEmmai from '../../../../../hooks/providers/useEmmai';
import Button from '../../../../form/buttons/Button/Button';
import usePractitionerNavigation from '../usePractitionerNavigation/usePractitionerNavigation';

const AddPractitionerButton = ({variant = 'toolbar'}) => {
  const {setCurrentForm, setIsPractitionerUpdating} = useEmmai();
  const {goToAddPractitioner} = usePractitionerNavigation({
    setCurrentForm,
    setIsPractitionerUpdating
  });
  const isSmallScreen = useBreakpoint() === BREAKPOINTS.xs;

  const text = isSmallScreen ? 'Ajouter' : 'Ajouter un praticien';
  const isToolbar = variant === 'toolbar';

  const toolbarStyles = {
    backgroundColor: 'white',
    color: 'primary',
    fontWeight: 600,
    fontSize: 11,
    maxHeight: 20,
    mr: {xs: 0.5, sm: 1},
    '&:hover': {
      backgroundColor: '#dedede'
    }
  };

  const defaultStyles = {};

  return (
    <Button onClick={goToAddPractitioner} size={isToolbar ? 'small' : 'medium'} color={isToolbar ? 'white' : 'secondary'} variant="contained" sx={isToolbar ? toolbarStyles : defaultStyles}>
      {text}
    </Button>
  );
};

AddPractitionerButton.propTypes = {
  variant: PropTypes.oneOf(['toolbar', 'form'])
};

export default AddPractitionerButton;
